import api from "./axios";

export async function getCommentary(device_id) {
  const response = await api.get(`/devicecoms/${device_id}`);
  return response;
}

export async function postCommentary(commentary) {
  const response = await api.post("/devicecoms", commentary);
  return response;
}

export async function deleteCommentary(commentaryId) {
  const response = await api.delete(`/devicecoms/${commentaryId}`);
  return response;
}

export async function putCommentary(commentary, commentaryId) {
  const response = await api.put(`/devicecoms/${commentaryId}`, commentary);
  return response;
}
